export type ScheduledSheetMode = 'create' | 'edit' | 'readonly';

export function resolveScheduledSheetMode(
  publish: { status?: string | null; cancelled_at?: string | null } | null | undefined,
): ScheduledSheetMode {
  if (!publish) return 'create';
  if (publish.status === 'scheduled' && !publish.cancelled_at) return 'edit';
  return 'readonly';
}
